module.exports = __webpack_public_path__ + "img/stop-watch-2x.3dbbe8b2.png";